<template>
    <div class="main">
        <c-panel>
            
            <el-row :gutter="10">
                <el-col :xs="24" :sm="12" :md="12">
                    
                    <h4 style="text-transform: uppercase;">{{ dados.titulo }}</h4>
                    <p v-html="dados.descricao"></p>

                </el-col>
                <el-col :xs="24" :sm="12" :md="12">
                    
                    <div class='embed-container'>
                        <iframe :src='dados.url' frameborder='0' allowfullscreen></iframe>
                    </div>
 
                </el-col>
            </el-row>

        </c-panel>
    </div>
</template>
<script>

export default {
    data: () => ({
        loading: false,
        dados: {}
    }),
    mounted () {
      
        this.getAjuda();
    },
    methods: {
        getAjuda(){

            this.loading = true;
            
            this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/ajuda/getById/${this.$route.params.id}`, this.$store.getters.getHeaderAuth).then(response => {

                this.dados = response.data;
                this.loading = false;

            }).catch((error) => { this.$store.commit('throwException', error); });

        }
    },
    components:{  }
}
</script>